import {AutomationFlow, AutomationNode, NodeType} from 'crqlar-react-common/dist/models/automation/automation';

/**
 * Retired types that can no longer be activated or run (AUTOMATIONS_UI.md, Decisions). Compared as
 * strings because they are gone from NodeType.
 */
export const RETIRED_NODE_TYPES: string[] = ['LOOP', 'GET_PROFILE'];

const isRetiredNodeType = (nodeType: unknown): boolean =>
    typeof nodeType === 'string' && RETIRED_NODE_TYPES.includes(nodeType);

/** A legacy Audience step with an inline `filter` instead of an `audienceId`. */
const hasInlineAudienceFilter = (node: AutomationNode): boolean => {
    if (node.type !== NodeType.AUDIENCE) return false;

    const config = node.config ?? {};
    const audienceId = typeof config.audienceId === 'string' ? config.audienceId.trim() : config.audienceId;
    if (audienceId) return false;

    return !!config.filter && typeof config.filter === 'object';
};

export const isLegacyAutomationNode = (node: AutomationNode): boolean =>
    isRetiredNodeType(node?.type) || hasInlineAudienceFilter(node);

export const isLegacyAutomationFlow = (flow?: AutomationFlow): boolean =>
    !!flow?.nodes?.some(isLegacyAutomationNode);
